import { render } from "./OrbitPosts.vue?vue&type=template&id=aee25f54"
import script from "./OrbitPosts.vue?vue&type=script&lang=js"
export * from "./OrbitPosts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__